import styled from 'styled-components';

/**
 * Card body for a truncation popover that reveals a clipped label's full text.
 * Wraps long content instead of overflowing the card.
 */
export const TruncationPopoverContent = styled.div`
  max-width: 448px;
  white-space: normal;
  overflow-wrap: anywhere;
`;
